import 'babel-polyfill';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '../../directives'
import '../../utils/filter'
import TeachingUI from 'teaching-ui'

import '../../plugins/element.js'
import store from '../../store'

import { Tab, Tabs, Icon, Popover, Swipe, SwipeItem, Popup } from 'vant';
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Popover);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);

Vue.config.productionTip = false
Vue.use(TeachingUI)

new Vue({
  render: h => h(App),
  router,
  store,
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  },
  methods: {
    setHeaderBackground: function () {
      const header = this.$root.$children[0].$refs.navigation
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 80) {
        header.type = "primary"
      } else {
        header.type = this.$route.meta.header
      }
    },
    activeNavigation: function (command) {
      const header = this.$root.$children[0].$refs.navigation
      header.setActive(command)
    }
  }
}).$mount('#app')
